var cpGetPageAjax = cpGetPageAjax || {};
(function (obj) {
  var url = '';
  var container = jQuery('#newsContainer');
  var pagination = jQuery('#newsPagination');
  var paginationLinks;
  var preloader = jQuery('#newsPreloader');
  var startPage = 1;
  var scrollOffset = 150;
  var currentPage = startPage;
  var sourceId = '';
  var sourceIdParam = '?sid=';
  var pageParam = '&page=';
  var isLoading = false;
  var attrData = 'data-page';
  var next = '+';
  var prev = '-';
  var first = 'first';
  var clsPreloaderActive = 'active';

  var checkURL = function (param) {
    var obj = {};
    var paramsArray = [];
    var result = '';
    var queryString = window.location.search;
    if (queryString) {
      queryString = queryString.split('?');
      queryString.shift();
      queryString = queryString[0];
      paramsArray = queryString.split('&');
      paramsArray.forEach(function (el) {
        var paramName = el.split('=')[0];
        var paramValue = el.split('=')[1];
        if (paramValue) {
          paramValue = paramValue.toLowerCase();
        }
        obj[paramName] = paramValue;
      });
    }
    Object.keys(obj).forEach(function (key) {
      if (key == param) {
        result = obj[key];
      }
    });
    return result;
  };

  var changeURL = function (sid, page) {
    var url = window.location.href.split('?')[0] + sid + page;
    window.history.pushState({}, '', url);
  }

  var toggleLoading = function () {
    if (!preloader || !preloader.length) {
      return;
    }
    if (isLoading) {
      isLoading = false;
      preloader.removeClass(clsPreloaderActive);
    } else {
      isLoading = true;
      preloader.addClass(clsPreloaderActive);
    }
  }

  var request = function (page, source) {
    page = page || '';
    source = source || '';
    let delimiter = '';
    if (page && source) {
      delimiter = '&'
    }
    toggleLoading();
    return $.ajax({
      url: url + source + delimiter + page,
      dataType: 'html',
      success: function (html) {
        var parser = new DOMParser();
        var dom = parser.parseFromString(html, 'text/html');
        var results = dom.querySelector('#getResContent').children;
        var pages = dom.querySelector('#paginationContent').children;
        container.empty();
        container.html(results);
        pagination.empty();
        pagination.html(pages);
        changeURL(source, page);
        bindOnPageClick();
        scrollTo(container);
        toggleLoading();
      }
    });
  };

  var getData = function () {
    var page = 0;
    var source = '';
    page = currentPage;
    source = sourceIdParam + sourceId;
    if (currentPage < 2) {
      currentPage = 1;
      page = '';
    } else {
      page = pageParam + currentPage;
    }
    request(page, source);
  }

  var bindOnPageClick = function () {
    paginationLinks = jQuery('.cp-pagination').find('ul').find('a');
    paginationLinks.off('click');
    paginationLinks.on('click', function (e) {
      e.preventDefault();
      var target = e.target;
      if (!target.hasAttribute(attrData)) {
        target = $(this).closest('a').get(0);
      }
      if (target.classList.contains('active') || isLoading) {
        return;
      }
      var page = target.getAttribute(attrData);
      if (page !== currentPage) {
        if (page !== next && page !== prev) {
          if (page === first) {
            currentPage = 1;
            page = 0;
          } else {
            page = parseInt(page);
            currentPage = parseInt(page);
          }
        } else {
          if (page === next) {
            currentPage += 1;
          }
          if (page === prev) {
            currentPage -= 1;
          }
        }
        getData(currentPage);
      }
    });
  }

  var scrollTo = function (element) {
    if (!element) {
      return;
    }
    var offset = element.offset().top - scrollOffset;
    jQuery([document.documentElement, document.body]).animate({
      scrollTop: offset
    }, 100)
  }

  obj.init = function (Url, Source) {
    url = Url;
    sourceId = Source;
    if (!url || !sourceId) {
      console.error('Url and Source params are not set!');
      return;
    }
    if (container) {
      currentPage = parseInt(checkURL('page') || startPage);
      bindOnPageClick();
    }
  }

})(cpGetPageAjax);